// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Common Client V2 imports
const ArticleCard = require('client-v2/common/components/cards/article')
const CollectionCard = require('client-v2/common/components/cards/collection')
// Convenience; in lieu of JSX transpiling...
const { createElement: tag } = React

const bem = BemEntity('TopCallToActionSplitTrailingList')

function TopCallToActionSplitTrailingList(props) {
  return tag('div', {
    className: classNames(
      bem.block(),
      props.className
    )
  },
    tag('div', {
      className: bem.element('item', 'collection')
    },
      tag(CollectionCard, {
        className: bem.element('card', 'collection'),
        // Flags
        isHrefsEnabled: false,
        // Values
        collection: props.collection,
        placeholderImage: props.placeholderImage,
        // Callbacks
        onFollowClick: props.onSignupClick
      }),
      tag('div', {
        className: bem.element('card-heading', 'collection')
      },
        `Follow and create`,
        tag('br'),
        `collections you love.`
      )
    ),

    tag('div', {
      className: bem.element('item', 'article')
    },
      tag(ArticleCard, {
        className: bem.element('card', 'article'),
        // Flags
        isHrefsEnabled: false,
        // Values
        article: props.article,
        placeholderImage: props.placeholderImage,
        // Callbacks
        onAddClick: props.onSignupClick
      }),
      tag('div', {
        className: bem.element('card-heading', 'article')
      },
        `Articles, images, videos, music.`
      ),
      tag('div', {
        className: bem.element('card-subheading', 'article')
      },
        `
          Save anything, from anywhere.
          If it's on the internet, you can add it to Mix.
        `
      )
    )
  )
}

module.exports = TopCallToActionSplitTrailingList
